//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
import { DatetimePicker, Field, Dialog, Overlay } from 'vant'
import 'vant/lib/datetime-picker/style'
import 'vant/lib/dialog/style'
import 'vant/lib/overlay/style'

export default {
  name: 'LMP',
  components: {
    [DatetimePicker.name]: DatetimePicker,
    [Dialog.Component.name]: Dialog.Component,
    [Field.name]: Field,
    [Overlay.name]: Overlay
  },
  data() {
    return {
      lastSadDate: '', // 末次月经日期
      babyBornDate: '', // 预产期
      gestationalWeek:{
        weeks:0,
        days:0
      },//孕周
      currentDate: '',
      showDatetimePicker: false,
    }
  },
  async mounted() {
    hiddenTitleBar(true)
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
    timeFormat(val) {
      if (!val) {
        return
      }
      let date = new Date(val)
      let Y = date.getFullYear()
      let M =
        (date.getMonth() + 1 < 10
          ? '0' + (date.getMonth() + 1)
          : date.getMonth() + 1)
      let D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()

      return Y + '年' + M + '月' + D + '日'
    },
    // 选择日期弹窗
    handleDateConfirm() {
      if (!this.currentDate) {
        return
      }
      // 末次月经  时间选择
      this.lastSadDate = this.currentDate

      let date = new Date(this.currentDate)
      date = this.calculateDueDate(date)
      console.log(90, date)
      this.babyBornDate = date

      //当前孕周
      this.gestationalWeek = this.computeGestationalWeek(this.currentDate)
      this.showDatetimePicker = false
    },
    handlePickDate(type) {
      if (type == 'lastSadDate') {
        this.currentDate = this.lastSadDate ? new Date(this.lastSadDate) : new Date()
        this.showDatetimePicker = true
      } else if (type == 'babyBornDate') {
        this.currentDate = this.babyBornDate ? new Date(this.babyBornDate) : new Date()
        this.showDatetimePicker = true
      } else {
        return
      }
    },
    //计算孕周
    computeGestationalWeek(currentDate){
      let now = new Date().getTime();
      let start = new Date(this.lastSadDate).getTime();
      let value = now - start;
      const standard = 3600*24*7*1000;
      let weeks=0,days=0
      if(value>0) {
        weeks = Math.floor(value/standard)
        let temp = value-weeks*standard
        days = Math.ceil(temp/(3600*24*1000))
        //如果是第七天算一周
        if(days===7) {
          weeks+=1
          days = days-7
        }
        console.log(value,standard,weeks,Math.ceil(temp/(3600*24*1000)))
      }
      return {weeks,days}
    },
    calculateDueDate(lastMenstrualDate) {
      // 解析末次月经日期
      var lastDate = new Date(lastMenstrualDate);
      var year = lastDate.getFullYear();
      var month = lastDate.getMonth() + 1; // 月份是从0开始的，所以要加1
      var day = lastDate.getDate();

      // 计算预产期月份和日期
      var dueDateMonth, dueDateYear, dueDateDay;

      if (month < 3) {
        dueDateMonth = month + 9;
        dueDateYear = year;
      } else {
        dueDateMonth = month - 3;
        dueDateYear = year + 1;
      }

      // 判断日期是否超过当月天数
      var daysInMonth = new Date(dueDateYear, dueDateMonth, 0).getDate();
      if (day > daysInMonth) {
        dueDateMonth += 1;
        if (dueDateMonth > 12) {
          dueDateMonth = 1;
          dueDateYear += 1;
        }
      }
      dueDateDay = day + 7;

      // 返回预产期日期
      var dueDate = new Date(dueDateYear, dueDateMonth - 1, dueDateDay); // 月份需要减1
      return dueDate.toDateString();
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulas/ObGyn/LMP.vue